import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const processedRef = useRef(false);
    const [status, setStatus] = useState("Signing you in…");

    useEffect(() => {
        if (processedRef.current) return;
        processedRef.current = true;
        const params = new URLSearchParams(location.search);
        const code = params.get("code");
        const state = params.get("state");
        if (!code) {
            navigate("/login", { replace: true });
            return;
        }
        let stored = null;
        try {
            stored = sessionStorage.getItem("ocsv_oauth_state");
            sessionStorage.removeItem("ocsv_oauth_state");
        } catch { /* noop */ }
        if (stored && state && stored !== state) {
            setStatus("Sign-in failed. Please try again.");
            setTimeout(() => navigate("/login", { replace: true }), 2000);
            return;
        }
        (async () => {
            try {
                // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
                const { data } = await api.post("/auth/google/exchange", {
                    code,
                    redirect_uri: window.location.origin + "/auth/google",
                });
                setUser(data);
                window.history.replaceState({}, document.title, "/");
                // Restore deep-link target if one was stashed before the OAuth bounce.
                let target = "/app";
                try {
                    const stashed = sessionStorage.getItem("opencsv:post-login-target");
                    if (stashed) {
                        target = stashed;
                        sessionStorage.removeItem("opencsv:post-login-target");
                    }
                } catch { /* ignore */ }
                if (data.has_access) {
                    navigate(target, { replace: true });
                } else {
                    // Trial expired and unpaid — send to pricing (never straight to Stripe).
                    navigate("/pricing", { replace: true });
                }
            } catch (e) {
                setStatus(formatApiErrorDetail(e.response?.data?.detail) || "Sign-in failed. Please try again.");
                setTimeout(() => navigate("/login", { replace: true }), 2000);
            }
        })();
    }, [location.search, navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-paper" data-testid="auth-callback">
            <div className="text-center">
                <div className="ui-heading text-xs uppercase tracking-widest text-ink-muted mb-3">/ google sign in</div>
                <div className="font-display font-black text-3xl tracking-tighter">{status}</div>
            </div>
        </div>
    );
}
